import API from '../../../../utils/api';
import { showPopupCashoutsPending } from '../../../Retirar/PopupCashoutsPending';

// Esta función espera a que el usuario cancele los retiros pendientes y
// retorna true si el usuario cancela, false si el usuario continúa con el pago
export const waitUserCancelCashoutsPending = async ({
  buttonConfirm = 'Continuar con Depósito',
  buttonCancel = 'Cancelar Depósito',
} = {}) => {
  const cashoutsPendingResponse = await API.getCashoutsPending();
  const cashoutsPending = cashoutsPendingResponse.data.cashouts;

  // Si tiene retiros pendientes mostrar popup de retiros pendientes
  if (cashoutsPending.length > 0) {
    const usedCashoutPending = await showPopupCashoutsPending({
      buttonConfirm,
      buttonCancel,
    });

    // Si usuario cancelo algun retiro se corta el flujo de pago
    if (usedCashoutPending === 'WAS_CANCELLED_PENDING') {
      return true;
    }
  }

  return false;
};
